<template>
  <FaqIndex :gnb-data="gnbData" />
</template>

<script setup lang="ts">
const { t } = useLocale()

definePageMeta({
  pageTransition: false,
  layoutTransition: true,
  layout: 'center',
  middleware: [
    'naver-ads',
    'kakao-pixel'
  ]
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '고객센터',
  description: '유심사의 \'무엇이든 물어보세요.\' eSIM, USIM 사용방법, 구매 및 환불 등이 어렵다면 지금 확인해 보세요.',
  ogType: 'website',
  ogUrl: () => ogUrl('board/faq'),
  ogTitle: () => ogTitle('고객센터'),
  ogDescription: '유심사의 \'무엇이든 물어보세요.\' eSIM, USIM 사용방법, 구매 및 환불 등이 어렵다면 지금 확인해 보세요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('고객센터'),
  twitterDescription: '유심사의 \'무엇이든 물어보세요.\' eSIM, USIM 사용방법, 구매 및 환불 등이 어렵다면 지금 확인해 보세요.',
  keywords: keyword('고객센터, eSIM고객센터, 이심고객센터, USIM고객센터, 유심고객센터')
})

const gnbData = ref({
  text: t('faq.inquiry'),
  url: '/board/contact-channel'
})

</script>
